import apiFetch from '../../apiFetch'

export default function (stockDossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/confirmDateStock/${stockDossierId}`, method: 'PUT', token: token, lastAccessDate })
}
